import { Stack, InputLabel } from "@mui/material";
import { useTranslations } from "next-intl";
import {
  TextareaAutosizeElement,
  TextFieldElementProps,
} from "react-hook-form-mui";

export const FormTextArea = ({
  label,
  placeholder,
  ...props
}: TextFieldElementProps) => {
  const t = useTranslations();
  return (
    <Stack spacing={1}>
      <InputLabel sx={{ fontWeight: 500, lineHeight: 1 }}>
        {typeof label === "string" ? t(label) : label}
      </InputLabel>
      <TextareaAutosizeElement
        placeholder={t(placeholder ?? "")}
        {...props}
        resizeStyle="none"
      />
    </Stack>
  );
};
